import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e0ed5b9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer-top" }
const _hoisted_3 = { class: "address-info" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { class: "app-store-button-container" }
const _hoisted_6 = { class: "footer-bottom" }
const _hoisted_7 = { class: "footer-icons" }
const _hoisted_8 = ["href"]
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "footer-links" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Image = _resolveComponent("Image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.$t('common.hanwha_address')), 1),
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('common.qcells_copyright_year', { year: _ctx.FOOTER_COPYRIGHT_YEAR })), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Image, {
          class: "link app-store-button",
          src: `store/apple/storebadge_${_ctx.languageCode}`,
          extension: "svg",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onOpenMobileAppLinkModal', _ctx.APP_STORE_TYPE.APPLE)))
        }, null, 8, ["src"]),
        _createVNode(_component_Image, {
          class: "link app-store-button",
          src: `store/google/storebadge_${_ctx.languageCode}`,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onOpenMobileAppLinkModal', _ctx.APP_STORE_TYPE.GOOGLE)))
        }, null, 8, ["src"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("a", {
          class: "sns-link",
          href: _ctx.FACEBOOK_URL,
          target: "_blank"
        }, [
          _createVNode(_component_Image, {
            src: "icons/ic_sns_facebook_gray",
            extension: "svg"
          })
        ], 8, _hoisted_8),
        _createElementVNode("a", {
          class: "sns-link",
          href: _ctx.INSTAGRAM_URL,
          target: "_blank"
        }, [
          _createVNode(_component_Image, {
            src: "icons/ic_sns_instagram_gray",
            extension: "svg"
          })
        ], 8, _hoisted_9),
        _createElementVNode("a", {
          class: "sns-link",
          href: _ctx.LINKEDIN_URL,
          target: "_blank"
        }, [
          _createVNode(_component_Image, {
            src: "icons/ic_sns_linkedin_gray",
            extension: "svg"
          })
        ], 8, _hoisted_10)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("a", {
          class: "text-link",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('onOpenPrivacyPolicyModal')))
        }, _toDisplayString(_ctx.$t('message.terms_personal_privacy')), 1)
      ])
    ])
  ]))
}